var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisualizer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 4C26.1193 4 25 5.11929 25 6.5V41.5C25 42.8807 26.1193 44 27.5 44C28.8807 44 30 42.8807 30 41.5V6.5C30 5.11929 28.8807 4 27.5 4ZM13.5 7C12.1193 7 11 8.11929 11 9.5V38.5C11 39.8807 12.1193 41 13.5 41C14.8807 41 16 39.8807 16 38.5V9.5C16 8.11929 14.8807 7 13.5 7ZM6.5 16C5.11929 16 4 17.1193 4 18.5V29.5C4 30.8807 5.11929 32 6.5 32C7.88071 32 9 30.8807 9 29.5V18.5C9 17.1193 7.88071 16 6.5 16ZM18 12.5C18 11.1193 19.1193 10 20.5 10C21.8807 10 23 11.1193 23 12.5V35.5C23 36.8807 21.8807 38 20.5 38C19.1193 38 18 36.8807 18 35.5V12.5ZM32 12.5C32 11.1193 33.1193 10 34.5 10C35.8807 10 37 11.1193 37 12.5V35.5C37 36.8807 35.8807 38 34.5 38C33.1193 38 32 36.8807 32 35.5V12.5ZM41.5 16C40.1193 16 39 17.1193 39 18.5V29.5C39 30.8807 40.1193 32 41.5 32C42.8807 32 44 30.8807 44 29.5V18.5C44 17.1193 42.8807 16 41.5 16Z",
    fill: "#858199"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisualizer);
export default __webpack_public_path__ + "static/media/iconVisualizer.97bc9401.svg";
export { ForwardRef as ReactComponent };